export default {"src":"/_next/static/media/warning.47d6ed03.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};